export const TRAVEL_HISTORY = {
  key: 'TRAVEL_HISTORY',
  value: 14,
  group: 1,
  title: 'health-record.travel-history.title',
  menu_title: 'health-record.travel-history.title',
  sub_title: 'health-record.travel-history.travel-history-title-example',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Travel.svg'),
  icon: 'airplane-takeoff',
  editor: 'TravelHistoryEditor',
  message_translate: 'health-record.travel-history.message',
  model_name: 'travel_history',
  resource: 'hr/travelhistory/',
  plain_resource: 'travelhistory',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.travel-history.country',
      value: 'record.country.value',
    },
    {
      text: 'health-record.travel-history.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.travel-history.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      country: {
        value: 'country',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(95.08deg, #8BC34A 2.49%, #8FC650 97.19%)',
  color: '#8BC34A',
  opaque: '#E4EFD7',
}
